/* eslint-disable @typescript-eslint/naming-convention */
export const LanguageToCode: {
  [key: string]: string;
} = {
  English: 'en',
  'Indonesian [iOS]': 'id',
  'Indonesian [Android]': 'in',
  Khmer: 'km',
  Korean: 'ko',
  Malay: 'ms',
  Burmese: 'my',
  Thai: 'th',
  Vietnamese: 'vi',
  Chinese: 'zh',
};

export const Operators = {
  in: 'in',
  'not in': 'not in',
  'in area': 'in area',
  contains: 'contains',
  'not contains': 'does not contain',
  '=': 'equals',
  '>': 'greater',
  '>=': 'greater or equals',
  '<': 'less than',
  '<>': 'not equals',
  '<=': 'less or equals',
  ex: 'regex',
  '/': 'targeted at',
  slot: 'slot',
};

export const ServiceBlackListedFacets = {
  paxapp: ['svc'],
  daxapp: ['svc'],
};

export const OsTypes = { ios: 'iOS', android: 'Android' };

export const StageTypes = {
  prod: 'Production',
  dev: 'Development',
  beta: 'Grab Early Access',
};

export const FoodBusinessTypes = {
  FOOD: 'FOOD',
  MART: 'MART',
  SHOP: 'SHOP',
  LS: 'LOCAL SERVICE',
};

export const DeviceScreenFactors = {
  ldpi: 'ldpi (Android)',
  mdpi: 'mdpi (Android)',
  hdpi: 'hdpi (Android)',
  xhdpi: 'xhdpi (Android)',
  xxhdpi: 'xxhdpi (Android)',
  xxxhdpi: 'xxxhdpi (Android)',
  '1.0': '1.0 (iOS)',
  '2.0': '2.0 (iOS)',
  '3.0': '3.0 (iOS)',
};

export const availableFacetValuesMap = {
  ost: OsTypes,
  stage: StageTypes,
  fbt: FoodBusinessTypes,
  dsf: DeviceScreenFactors,
};
